import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLeads from "@/pages/admin/AdminLeads";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/leads")({
  head: () => adminHead("Leads | Admin", "Lead capture and pipeline management.", "/admin/leads"),
  component: () => (
    <ProtectedRoute>
      <AdminLeads />
    </ProtectedRoute>
  ),
});
